import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { useNavContext } from '../useNavContext'
import useWindowSize from '@toasttab/shared/src/hooks/useWindowSize'
import _helpers from '@toasttab/shared/src/globals/_helpers'
import ShowcaseEntry from '../ShowcaseEntry'
import SubMenuEntry from '../SubMenuEntry'
import { MenuProps } from '../ContentfulNavigation'

const DesktopMenu = ({ dropdownContent, handleCloseNav, title }: MenuProps) => {
  const [isHidden, setIsHidden] = useState(true)
  const { selectedParentMenu, setDesktopNavHeight } = useNavContext()

  const navMenuRef = useRef(null)

  useEffect(() => {
    if (title === selectedParentMenu) {
      setIsHidden(false)
    } else {
      setIsHidden(true)
    }
  }, [title, selectedParentMenu])

  useEffect(() => {
    if (!isHidden) {
      setDesktopNavHeight(navMenuRef?.current?.offsetHeight)
    }
  }, [isHidden, setDesktopNavHeight])

  const windowSize = useWindowSize()

  const handleMouseLeave = () => {
    // Keeps the menu open if the mouse moves up to the heading, closes it if they leave the nav item entirely
    if (title !== selectedParentMenu) {
      handleCloseNav()
    }
  }

  const menuClasses = classNames(
    'lg:flex transition-opacity duration-300 fixed w-full top-[72px] left-0 z-20',
    {
      // using visibility: hidden; over display: none; to allow the opacity transition to function
      'invisible opacity-0 top-[-9999px]': isHidden,
      'opacity-100 top-0': !isHidden
    }
  )

  return (
    <nav
      aria-hidden={windowSize.width < 1024 || title !== selectedParentMenu}
      aria-label={`Toast ${title} Dropdown Menu`}
      className={menuClasses}
      data-testid='DesktopMenu'
      id={`${title.replace(/\s/g, '-')}-menu`}
      key={`desktop-sub-menu-${title}`}
      onMouseLeave={handleMouseLeave}
      ref={navMenuRef}
    >
      <div className='grid grid-cols-4 gap-6 max-w-[1128px] w-full py-10 px-11 xl:px-0 mx-auto'>
        {dropdownContent?.showcaseEntries ? (
          // p-[2px] to allow extra space for accessibility focus outlines
          <div className='overflow-y-scroll !no-scrollbar p-[2px]'>
            {dropdownContent?.showcaseEntries.map((showcase: any) => (
              <ShowcaseEntry key={showcase.title} {...showcase} />
            ))}
          </div>
        ) : null}
        <div className='col-span-3 grid grid-cols-3 gap-x-6 gap-y-8 w-full rounded-br-lg overflow-y-scroll !no-scrollbar p-[2px]'>
          {dropdownContent?.subMenus?.columns?.map((column: any, i: number) => (
            <div key={`desktop-sub-menu-column-${title}-${i}`}>
              {column.map((submenu: any) => (
                <SubMenuEntry
                  key={`desktop-sub-menu-section-${submenu.title}}`}
                  {...submenu}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </nav>
  )
}

export default DesktopMenu
